import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/use-auth";

interface BadgeCounts {
  friendsBadge: number;
  profileBadge: number;
}

async function fetchBadges(): Promise<BadgeCounts> {
  const res = await fetch("/api/badges", { credentials: "include" });
  if (!res.ok) throw new Error(`${res.status}: ${await res.text()}`);
  return res.json();
}

export function useBadges() {
  const { user } = useAuth();
  const userId = (user as any)?.id;
  const query = useQuery({
    queryKey: ["/api/badges", userId],
    queryFn: fetchBadges,
    enabled: !!user,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
  if (!user) return { friendsBadge: 0, profileBadge: 0 };
  return {
    friendsBadge: query.data?.friendsBadge ?? 0,
    profileBadge: query.data?.profileBadge ?? 0,
  };
}
